import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { ICONS } from '@core/services/icons/icons.service';

/**
 * Key for the calendar's two novel marks, plus the event count.
 *
 * There is deliberately no colour key: the scale is per-schedule (derived from
 * the compatible commodities), so a swatch list would reflow on every
 * navigation and still not name a stable category.
 */
@Component({
  selector: 'app-calendar-legend',
  imports: [TranslatePipe],
  templateUrl: './calendar-legend.component.html',
  styles: ``
})
export class CalendarLegendComponent {
  eventCount = input.required<number>();

  protected readonly ICONS = ICONS;
}
